export default {
  data() {
    return {
      merchant: this.$store.state.merchant,
      tab: 0,
      request: this.$store.state.request,
      views: {
        analysis: false,
        more: false,
        schedule: false,
        payment: false,
        customer: false,
        repayment: false,
        eligibility: false,
        email: false,
        data: false
      }
    }
  },
  metaInfo() {
    return {
      title: 'Order details',
    }
  },
  created() {
    this.check();
  },
  methods: {
    check() {
      if (this.status > 2) return;
      if (this.$store.getters['request/credit']) {
        if (!this.emailVerified) this.showView('email');
        else if (this.doAnalysis && !this.analysisDone) {
          if (this.$store.state.merchant.widget === 1) this.showView('data');
          else this.showView('eligibility');
        } else if (this.doCollection && !this.collectionDone) this.showView('repayment');
        else if (!this.upfrontPaid) return this.showView('payment');
      } else {
        if (!this.upfrontPaid) this.views.payment = true;
      }
    },
    async eligibilityDone() {
      this.views.customer = false;
      if (this.$store.getters['request/runMBS']) this.views.mbs = true
      else this.views.eligibility = true;
    },
    paymentDone() {
      this.views.payment = false;
    },
    reset() {
      this.closeViews();
      this.check();
    }
  },
  computed: {
    emailVerified() {
      return this.$store.getters["request/emailVerified"]
    },
    doAnalysis() {
      return this.$store.getters["request/doAnalysis"]
    },
    analysisDone() {
      return this.$store.getters["request/analysisDone"]
    },
    upfrontPaid() {
      return this.$store.getters["request/upfrontPaid"]
    },
    doCollection() {
      return this.$store.getters["request/doCollection"]
    },
    collectionDone() {
      return this.$store.getters["request/collectionDone"]
    },
    status() {
      return this.$store.state.request.req_status
    },
  }
}
